import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedSubscriptions, deleteSubscription } from '../../../services/subscriptionService';
import { Subscription } from '../../../types/subscription';
import { getSubscriptionColumns } from './SubscriptionColumns';
import Table from '../../../components/common/Table';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import pageStyles from '../../Page.module.css';
//import sharedStyles from '../../SharedPageStyles.module.css';

import Icon from '../../../components/common/Icon';
interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};
const SubscriptionsListPage: React.FC = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [subscriptionToDelete, setSubscriptionToDelete] = useState<Subscription | null>(null);

  const openDeleteDialog = (subscription: Subscription) => {
    setSubscriptionToDelete(subscription);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setSubscriptionToDelete(null);
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    if (!subscriptionToDelete) return;
    const promise = deleteSubscription(subscriptionToDelete.id);
    toast.promise(promise, {
      loading: 'جاري حذف الاشتراك...',
      success: () => {
        closeDeleteDialog();
        refreshData();
        return 'تم حذف الاشتراك بنجاح!';
      },
      error: (err) => {
        closeDeleteDialog();
        return err.response?.data?.message || 'فشل في حذف الاشتراك.';
      },
    });
  };

  const columns = useMemo(() => getSubscriptionColumns(openDeleteDialog), []);

  const { table, isLoading, Pagination, refreshData, searchTerm, 
    setSearchTerm, } = useServerSideTable<Subscription>({
    columns,
    fetchData: getPagedSubscriptions,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>إدارة الاشتراكات</h1>
        <Link to="/admin/subscriptions/add" className={pageStyles.addButton}>
            <Icon as={FaPlus} style={pageStyles.icon } />
          <span>إضافة اشتراك</span>
        </Link>
      </div>
      <div className={pageStyles.pageContent}>
        <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <Table<Subscription> table={table} isLoading={isLoading} />
        <Pagination />
      </div>
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من رغبتك في حذف الاشتراك رقم "${subscriptionToDelete?.id}"؟`}
        onConfirm={handleDelete}
        onCancel={closeDeleteDialog}
      />
    </div>
  );
};

export default SubscriptionsListPage;
